import { render, staticRenderFns } from "./FB.vue?vue&type=template&id=7b1cbbb4&scoped=true&"
import script from "./FB.vue?vue&type=script&lang=js&"
export * from "./FB.vue?vue&type=script&lang=js&"
import style0 from "./FB.vue?vue&type=style&index=0&id=7b1cbbb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1cbbb4",
  null
  
)

export default component.exports